(function () {
  'use strict';

  var diagnostics = [];
  var MAX_DIAGNOSTICS = 80;

  function sanitize(value, depth) {
    depth = Number(depth) || 0;
    if (value == null || typeof value === 'boolean' || typeof value === 'number') return value;
    if (typeof value === 'string') {
      if (/^(data:|blob:)/i.test(value)) return '[browser-local asset]';
      return value.length > 240 ? value.slice(0, 237) + '...' : value;
    }
    if (depth > 3) return '[nested]';
    if (Array.isArray(value)) return value.slice(0, 12).map(function (entry) { return sanitize(entry, depth + 1); });
    if (typeof value === 'object') {
      var output = {};
      Object.keys(value).slice(0, 24).forEach(function (key) {
        output[key] = /token|authorization|cookie|password|secret/i.test(key) ? '[redacted]' : sanitize(value[key], depth + 1);
      });
      return output;
    }
    return String(value);
  }

  function record(type, detail) {
    var entry = { at: new Date().toISOString(), type: String(type || 'runtime'), detail: sanitize(detail || {}, 0) };
    diagnostics.push(entry);
    if (diagnostics.length > MAX_DIAGNOSTICS) diagnostics.splice(0, diagnostics.length - MAX_DIAGNOSTICS);
    document.dispatchEvent(new CustomEvent('justpress:diagnostic', { detail: entry }));
    return entry;
  }

  function reportError(error, context, detail) {
    var normalized = error instanceof Error ? error : new Error(String(error || 'Unknown error'));
    var entry = record('runtime-error', {
      context: String(context || 'unknown'),
      name: normalized.name || 'Error',
      message: normalized.message || String(normalized),
      detail: detail || null
    });
    if (document.documentElement.classList.contains('shopify-design-mode') && window.console && console.warn) {
      console.warn('[JUSTPRESS]', entry.detail.context, normalized);
    }
    return entry;
  }

  function entries() { return diagnostics.slice(); }

  function toast(message, actionLabel, action) {
    var old = document.querySelector('[data-jp-runtime-toast]');
    if (old) old.remove();
    var node = document.createElement('div');
    node.className = 'jp-runtime-toast';
    node.setAttribute('data-jp-runtime-toast', '');
    node.setAttribute('role', 'status');
    var text = document.createElement('span');
    text.textContent = message;
    node.appendChild(text);
    if (actionLabel && typeof action === 'function') {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = actionLabel;
      button.addEventListener('click', function () { action(); node.remove(); }, { once: true });
      node.appendChild(button);
    }
    document.body.appendChild(node);
    requestAnimationFrame(function () { node.classList.add('is-visible'); });
    window.setTimeout(function () { if (node.isConnected) node.remove(); }, 6000);
  }


  function route(base, params) {
    var value = String(base || window.location.pathname || '/');
    var url;
    try { url = new URL(value, window.location.origin); } catch (_) { return value; }
    var current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
      if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    Object.keys(params || {}).forEach(function (key) {
      var entry = params[key];
      if (entry == null || entry === '') url.searchParams.delete(key);
      else url.searchParams.set(key, String(entry));
    });
    return url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.toString();
  }

  function setVisualViewport() {
    var viewport = window.visualViewport;
    var height = viewport ? viewport.height : window.innerHeight;
    var offsetTop = viewport ? viewport.offsetTop : 0;
    var layoutHeight = window.innerHeight || document.documentElement.clientHeight || height;
    var visualBottom = offsetTop + height;
    var bottomOffset = viewport ? Math.round(layoutHeight - visualBottom) : 0;
    if (!Number.isFinite(bottomOffset)) bottomOffset = 0;
    // iOS browsers can keep fixed elements attached to the layout viewport while
    // their visible viewport grows or shrinks with browser chrome and keyboards.
    // Keep the correction bounded so browser zoom or a transient bad metric can
    // never throw persistent controls off-screen.
    bottomOffset = Math.max(-180, Math.min(640, bottomOffset));
    document.documentElement.style.setProperty('--jp-visual-viewport-height', Math.max(320, Math.round(height)) + 'px');
    document.documentElement.style.setProperty('--jp-visual-viewport-offset', Math.max(0, Math.round(offsetTop)) + 'px');
    document.documentElement.style.setProperty('--jp-visual-viewport-bottom-offset', bottomOffset + 'px');
  }

  setVisualViewport();
  window.addEventListener('resize', setVisualViewport, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setVisualViewport, { passive: true });
    window.visualViewport.addEventListener('scroll', setVisualViewport, { passive: true });
  }

  document.addEventListener('justpress:storage-error', function () {
    toast('Your design could not be saved in this browser. Secure the upload or remove an unfinished image before leaving this page.', 'Return to set', function () {
      var url = window.jpRoutes && window.jpRoutes.customizer;
      if (url) window.location.assign(url);
    });
  });
  window.addEventListener('offline', function () { toast('You are offline. Editing can continue, but checkout and secure uploads need a connection.'); });
  window.addEventListener('online', function () { toast('Connection restored. You can retry saving or checkout.'); });

  window.JPRuntime = { toast: toast, refreshViewport: setVisualViewport, route: route, record: record, reportError: reportError, entries: entries };
})();
